import { gql } from "@apollo/client";

export default gql`
  mutation saveOrgWideCompetency(
    $competencyId: Int
    $organizationId: Int
    $title: String
    $description: String
    $appliesTo: CompetencyAppliesTo
    $criteriaUniqueness: CompetencyCriteriaUniqueness
    $appliesToManagementRoles: Boolean
    $appliesToIcRoles: Boolean
    $appliesToTeams: [Int]
    $appliesToCareerTracks: [Int]
    $criteria: [CompetencyCriteriaInput]
    $deleteCriteriaIds: [Int!]
  ) {
    createOrUpdateCompetency(
      competencyId: $competencyId
      organizationId: $organizationId
      title: $title
      description: $description
      appliesTo: $appliesTo
      criteriaUniqueness: $criteriaUniqueness
      appliesToManagementRoles: $appliesToManagementRoles
      appliesToIcRoles: $appliesToIcRoles
      appliesToTeams: $appliesToTeams
      appliesToCareerTracks: $appliesToCareerTracks
      criteria: $criteria
      deleteCriteriaIds: $deleteCriteriaIds
    ) {
      competency {
        id
        title
        description
        appliesTo
      }
      createdIds {
        clientId
        id
        kind
      }
    }
  }
`;
